// @flow

import React from 'react';
import type { InstitutionAddresses, InstitutionWithAddresses } from '../types/institution';
import type { AllStatuses } from '../types/status';
import ProviderCard from './shared/ProviderCard';

type Props = {
  addresses: InstitutionAddresses[],
  institutionsWithAddresses: InstitutionWithAddresses[],
  statuses: AllStatuses,
  showConsentForm: (requestId: number) => void
}

const ProviderCards = (props: Props) => {
  const { addresses, institutionsWithAddresses, statuses, showConsentForm } = props;

  let data: InstitutionWithAddresses[] = institutionsWithAddresses;

  if (!data) {
    // addresses into dictionary with parent institution's id as the key
    const institutionsDict = {};
    addresses.map((address) => {
      const id = address.institution ? address.institution.id : null;
      if (institutionsDict[id]) {
        institutionsDict[id].addresses.push(address);
      } else {
        institutionsDict[id] = address.institution ? address.institution : { ...address };
        institutionsDict[id].addresses = [address];
      }
      return null;
    });
    data = Object.keys(institutionsDict).map((key) => institutionsDict[key]);
  }
  return (
    <main>
      {data.map((institution, i) => {
        return (
          <ProviderCard
            key={i}
            name={institution.institution_name}
            institution={institution}
            className='has-list'
            types={institution.types}
            statuses={statuses}
            showConsentForm={showConsentForm}
          />
        );
      })}
    </main>
  );
};

export default ProviderCards;


// WEBPACK FOOTER //
// ./src/components/provider-cards.js